var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMemberDownIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14.1128,
    height: 12,
    rx: 3,
    fill: "var(--icon-bg, currentColor)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00148 4.56763C3.00121 4.43524 3.04827 4.30693 3.13447 4.20498C3.18301 4.14761 3.24262 4.10018 3.30989 4.06542C3.37716 4.03065 3.45077 4.00924 3.52651 4.00239C3.60224 3.99555 3.6786 4.00342 3.75123 4.02554C3.82385 4.04766 3.89131 4.08361 3.94974 4.13132L7.04893 6.66984L10.1539 4.22198C10.213 4.17492 10.2811 4.13977 10.3541 4.11856C10.4272 4.09735 10.5038 4.09049 10.5796 4.09839C10.6553 4.10629 10.7287 4.12878 10.7956 4.16458C10.8625 4.20038 10.9215 4.24877 10.9692 4.30698C11.0218 4.36561 11.0615 4.43426 11.0858 4.50864C11.1101 4.58302 11.1184 4.66151 11.1103 4.73919C11.1021 4.81687 11.0777 4.89207 11.0385 4.96005C10.9993 5.02804 10.9461 5.08735 10.8824 5.13426L7.4132 7.8711C7.30974 7.95444 7.17996 8 7.04604 8C6.91211 8 6.78233 7.95444 6.67887 7.8711L3.20963 5.03794C3.13966 4.98109 3.08435 4.90888 3.04818 4.82717C3.01201 4.74546 2.99601 4.65654 3.00148 4.56763Z",
    fill: "var(--icon-fg, var(--color-text-primary))"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberDownIcon);
export default __webpack_public_path__ + "static/media/member_down_icon.641ebfff7c8be4b4e240582a1eca0142.svg";
export { ForwardRef as ReactComponent };